import React from "react";
import cx from "classnames";
import { SupportLink } from "@/features/shell/components/shared/SupportLink";

import * as styles from "./ViewTermsLink.module.scss";

export const ViewTermsLink = ({
  link,
  className,
  isNotPaid = false,
}: { link?: string; className?: string; isNotPaid?: boolean }) => {
  const label = "View Terms";

  if (!link) {
    return (
      <SupportLink
        hideChevron
        options={{ labels: ["weblink-special-promotion-terms"] }}
        className={cx(styles.link, className, {
          [styles.soft]: isNotPaid,
        })}
      >
        {label}
      </SupportLink>
    );
  }

  return (
    <a
      className={cx(styles.link, className, {
        [styles.soft]: isNotPaid,
      })}
      href={link}
    >
      {label}
    </a>
  );
};
